import React, { useState, createContext } from 'react'

const NoteContext = createContext({})

export const NotesContainer = ({ children, notes, onSave }) => {
  const [openId, setOpenId] = useState('')

  const handleOnOpen = (id) => {
    setOpenId(id)
  }
  const handleOnCancel = () => {
    setOpenId(null)
  }

  const handleOnSave = (notesValues) => {
    onSave(notesValues)
    setOpenId(null)
  }

  return (
    <NoteContext.Provider
      value={{
        openId,
        notes,
        onSave: handleOnSave,
        onOpen: handleOnOpen,
        onCancel: handleOnCancel,
      }}
    >
      {children}
    </NoteContext.Provider>
  )
}

export default NoteContext
